function initNetreviewsSlider(slider) {
    $(slider).on('init', function (event, slick) {
        slick.$prevArrow.css('visibility', 'hidden');
    })

    $(slider).not('.slick-initialized').slick({
        dots: false,
        arrows: true,
        prevArrow: '<span class="slide-arrow prev">Prev</span>',
        nextArrow: '<span class="slide-arrow next">Next</span>',
        autoplay: false,
        infinite: false,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $(slider).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        slick.$prevArrow.css('visibility', 0 === nextSlide ? 'hidden' : 'visible')
        slick.$nextArrow.css('visibility', 0 >= (slick.slideCount - (nextSlide + 2)) ? 'hidden' : 'visible')
    });
}

function observeNetreviewsSlider() {
    const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initNetreviewsSlider(entry.target, 2);
                intersectionObserver.unobserve(entry.target);
            }
        });
    }, {rootMargin: '200px 0px'});

    intersectionObserver.observe(document.querySelector('.maier-footer-informations-reviews-list'));
}

function setupNetreviewsSlider() {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            observeNetreviewsSlider();
        })
    })
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupNetreviewsSlider);
} else {
    setupNetreviewsSlider();
}